export const environment = {
    production: true,
    serverUrl: '/api',
    formBuilder: {
        appId: 'B3LILJDAT',
        serverUrl: 'https://formbuilder.rapidinspectapp.com'
    },
    client: 'https://wpe.rapidinspectapp.com',
    APP_NAME: 'rapidInspect',
    RECAPTCHA_SITE_KEY : '6Lep9o8UAAAAAOFHNyHbzw80yt2fkUq_bmm2y6WG',
    RECURLY_PLAN_CODE: 'ri_core',
    QR_LINK: (inspection: string) => `https://wpe.rapidinspectapp.com/scan/qrcode/perform_inpsection?inspectionid=${inspection}`,
    NISS_TEMPLATE_ID: "fh_template:NISS:SHIFT",
    AESA_TEMPLATE_ID: "fh_template:AESS:ANEXO:18",
    DYNO_TEAM_ID: "45c7a50b66066da8239439a7e1868924",
    TAKE_5_TEMPLATE_ID: "fh_template:take5:v01"
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts